import ResponsibleRadio from './ResponsibleRadio';

export default ResponsibleRadio;
